import { condicaoPagamentoService } from '@/services/condicaoPagamentoService';

const getDefaultState = () => {
  return {
    condicoesPagamento: [],
    isModified: false
  }
}

const state = getDefaultState();

const getters = {
  condicoesPagamento: state => state.condicoesPagamento,
  isCondicoesPagamentoModified: state => !!state.isModified
};

const actions = {
  async fetchCondicoesPagamento({ commit }) {
    try {
      const response = await condicaoPagamentoService.getCondicoesPagamento();
      commit('SET_CONDICOES_PAGAMENTO', response);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
  async fetchCondicoesPagamentoAPI({ commit }) {
    try {
      const response = await condicaoPagamentoService.getCondicoesPagamentoAPI();
      commit('SET_CONDICOES_PAGAMENTO', response);
      commit('SET_IS_CONDICOES_PAGAMENTO_MODIFIED', true);
    } catch (error) {
      console.log(error);
      commit('SHOW_SNACKBAR', { text: error, status: 'error' });
    }
  },
};

const mutations = {
  CLEAR_CONDICOES_PAGAMENTO_STATE: state => Object.assign(state, getDefaultState()),
  SET_CONDICOES_PAGAMENTO: (state, condicoesPagamento) => state.condicoesPagamento = condicoesPagamento,
  SET_IS_CONDICOES_PAGAMENTO_MODIFIED: (state, isModified) => state.isModified = isModified
};

export default {
  state,
  getters,
  actions,
  mutations
}